/* eslint-disable no-restricted-syntax */
// components/ProductCardMemoized.jsx
/* eslint-disable react/prop-types */
import React, { memo } from 'react';
import ProductCard from './productCard/ProductCard';

/* eslint-disable arrow-body-style */
var ProductCardMemoizedSimple = /*#__PURE__*/memo(_ref => {
  var {
    storeStatus,
    image,
    category,
    name,
    isNewItem,
    isSpicy,
    description,
    price,
    url,
    productId,
    isCustomizable
  } = _ref;
  return /*#__PURE__*/React.createElement(ProductCard, {
    storeStatus: storeStatus,
    image: image,
    category: category,
    name: name,
    isNewItem: isNewItem,
    isSpicy: isSpicy,
    description: description,
    price: price,
    url: url,
    productId: productId,
    isCustomizable: isCustomizable
  });
});
ProductCardMemoizedSimple.displayName = 'ProductCardMemoizedSimple';
export { ProductCardMemoizedSimple };